import { render, staticRenderFns } from "./ChronicleIndex.vue?vue&type=template&id=b321b5f2&scoped=true&"
import script from "./ChronicleIndex.vue?vue&type=script&lang=js&"
export * from "./ChronicleIndex.vue?vue&type=script&lang=js&"
import style0 from "./ChronicleIndex.vue?vue&type=style&index=0&id=b321b5f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b321b5f2",
  null
  
)

export default component.exports